var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 307.7 238.1",
    style: {
      enableBackground: "new 0 0 307.7 238.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.24;}\n\t.st1{opacity:0.7;}\n\t.st2{fill:#E6E7E8;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.373;fill:#D1D3D4;enable-background:new    ;}\n\t.st5{fill:none;stroke:#A7A9AC;stroke-width:7.1736;stroke-linecap:round;}\n\t.st6{fill:#A7A9AC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.8,208.2c-47.6,20.3-97.5,32.8-135.6,29.3c-38.3-3.1-64.7-22.1-69.3-55.8c-5.1-33.4,13-72.9,37.2-105.2 C62.7,44,93.3,18.8,121.9,7.2c29.3-11.6,53.7-8.2,81.2,3.3c26.8,11.6,56.6,31.2,80.1,55.5c23.3,24.6,31.5,49.1,17.9,73.4 C288.2,163.5,253.3,187.4,205.8,208.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28_00000086672908599365729240000007338664287485996449_",
    transform: "translate(0.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 150.9,
    cy: 129,
    r: 80.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    className: "st4",
    cx: 155.4,
    cy: 132.5,
    r: 70.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28",
    transform: "translate(0.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 150.9,
    cy: 129,
    r: 80.4
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    className: "st6",
    cx: 188.8,
    cy: 122,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    className: "st6",
    cx: 115,
    cy: 122,
    r: 8.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    transform: "translate(28.464 50.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    className: "st5",
    x1: 162.4,
    y1: 32.3,
    x2: 175.2,
    y2: 40.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    className: "st5",
    x1: 71.2,
    y1: 58,
    x2: 84,
    y2: 49.8
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    className: "st5",
    x1: 155.5,
    y1: 158.7,
    x2: 166.2,
    y2: 153.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.bf76fdc2a4f3fa4ccd145737c3c19a1e.svg";
export { ForwardRef as ReactComponent };